import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { checkAuth } from '../services/authService';
import './LarkCallback.css';

const LarkCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    // 从 URL 参数获取数据 (后端重定向过来的)
    const token = searchParams.get('token');
    const redirect = searchParams.get('redirect');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(decodeURIComponent(errorParam));
      return;
    }

    if (!token) {
      setError('登录失败: 未获取到 Token');
      return;
    }

    // 用 token 调 checkAuth 获取完整用户信息（含 menuKeys）
    checkAuth(token).then(user => {
      if (user) {
        login(token, user);
        const redirectTo = redirect ? decodeURIComponent(redirect) : '/';
        navigate(redirectTo, { replace: true });
      } else {
        setError('登录失败: Token 验证失败');
      }
    }).catch(() => {
      setError('登录失败: 网络错误');
    });
  }, [searchParams, login, navigate]);

  if (error) {
    return (
      <div className="callback-page">
        <div className="callback-card">
          <div className="callback-error">
            <span className="error-icon">❌</span>
            <p>{error}</p>
          </div>
          <button className="back-btn" onClick={() => navigate('/login')}>
            返回登录
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="callback-page">
      <div className="callback-card">
        <div className="callback-loading">
          <div className="spinner"></div>
          <p>正在登录中...</p>
        </div>
      </div>
    </div>
  );
};

export default LarkCallback;
